define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty"
],
    function (lang, TypeConstants, TypeProperty, TagProperty) {
        var hash = {};

        hash[TypeConstants.POPUP_LIST] = lang.mixin({}, {
            maxHeight: {
                type: "number",
                defaultValue: 600,
                notInAction: true,
                required: false
            }
        }, TypeProperty, TagProperty);

        return hash;
    });

